module.exports = __webpack_public_path__ + "media/images/ilustrations/mesa-urna-89a80852681966ae2fedaa7e3cf30c6f.png";